import React from "react";
import { RichTextEditorContainer } from "./components";
import styles from "./CentralPanel.module.css";

const CentralPanel = ({ debouncedUpdateNote, editor, liveStatuses, noteStatus, onSetNoteStatus }) => (
	<div className={styles.container}>
		<RichTextEditorContainer
			debouncedUpdateNote={debouncedUpdateNote}
			editor={editor}
			liveStatuses={liveStatuses}
			noteStatus={noteStatus}
			onSetNoteStatus={onSetNoteStatus}
		/>
	</div>
);

export default CentralPanel;
